import * as React from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { ACollapse, TableCommittee } from "../../components";
import { DropDownMuti } from "../../components/core";
import moment from 'moment'

const ExtendConsiderationPeriodTable = ({items = [], onRowClick}) => {

    const [page, setPage] = React.useState(0)
    const [rowsPerPage, setRowsPerPage] = React.useState(10)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {

       setRowsPerPage(parseInt(event.target.value, 10))
    }

    const statusOptions = () => {
        return Promise.resolve([
            {
            value: "DRAF",	
            label: "Draft"
            },
            {
                value: "COMPLETE",
                label: "Complete"
            }
        ]);
    }

    const handleOnRowClick = (obj) => {
      if(typeof onRowClick === 'function')
      {
        onRowClick(obj)
      }
    }

    //const handlehandleDropdownMutiChange

  return (
    <TableContainer className="sp-table-container">
      <Table className="sp-table table rrs-table rrs-table-normal">
        <TableHead>
          <TableRow className="sp-table-header">
            <TableCell
              className="th-table text-center"
              style={{ width: "210px", maxWidth: "210px" }}
            >
              สถานะเอกสาร
            </TableCell>
            <TableCell
              className="th-table text-center"
              style={{ width: "140px", maxWidth: "140px" }}
            >
              PO/Contract No.
            </TableCell>
            <TableCell
              className="th-table text-center"
            >
              Header Text
            </TableCell>
            <TableCell
              className="th-table text-center"
              style={{ width: 180, maxWidth: 180 }}
            >
              Edit By
            </TableCell>
            <TableCell
              className="th-table text-center"
              style={{ width: 180, maxWidth: 180 }}
            >
              Edit Date
            </TableCell>
          </TableRow>
          <TableRow className="sp-table-filter">
             <TableCell >
              <DropDownMuti
                loadOptions={statusOptions}
                id="MUTI_STATUS"
                value={[]}
                className="form-control"
                placeholder=" "
                //onChange={this.handleDropdownMutiChange}
              ></DropDownMuti>
            </TableCell>
            <TableCell>
              <input
                type="text"
                placeholder=" "
                name="filter_mom_no"
                className="form-control"
                //onChange={this.handleChange}
                //value={filter_mom_no}
              />
            </TableCell>
            <TableCell>
              <input
                type="text"
                placeholder=" "
                name="filter_doc_no"
                className="form-control"
                //onChange={this.handleChange}
                //value={filter_doc_no}
              />
            </TableCell>
            <TableCell>
              <input
                type="text"
                placeholder=" "
                name="filter_po_contract_no"
                className="form-control"
                //onChange={this.handleChange}
                //value={filter_po_contract_no}
              />
            </TableCell>
            <TableCell>
              <input
                type="text"
                placeholder=" "
                name="filter_po_header_text"
                className="form-control"
                //onChange={this.handleChange}
                //value={filter_po_header_text}
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items ? (items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((inprogress, index) => {
                return (
                  <>
                    <TableRow
                      key={
                        "task_inprogress_" +
                        (page * rowsPerPage + index) +
                        "_" +
                        inprogress.transaction_no
                      }
                      style={{ cursor: "pointer" }}
                      onClick={()=> handleOnRowClick(inprogress)}
                    >
                      <TableCell
                        className="text-center"
                      >
                        {inprogress.status_name}
                      </TableCell>
                      
                      <TableCell
                        
                        className="text-center"
                      >
                        {inprogress.po_contract_no}
                      </TableCell>
                     
                      <TableCell
                      
                        className="text-left"
                      >
                        {inprogress.po_header_text}
                      </TableCell>
                      <TableCell
                      
                        className="text-left"
                      >
                        {inprogress.update_by_name}
                      </TableCell>
                      <TableCell
                      
                        className="text-center"
                      >
                        {moment(inprogress.update_date).format("DD/MM/YYYY")}
                      </TableCell>
                     
                    </TableRow>
                  </>
                );
              })
          ) : (
            <TableRow key={0}>
              {/* <TableCell colSpan="11" className="text-center" style={{ */}

              <TableCell
                colSpan="11"
                className="text-center"
                style={{
                  textAlign: "center",
                  fontStyle: "italic",
                  color: "gray",
                }}
              >
                No data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={items.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          "aria-label": "previous page",
        }}
        nextIconButtonProps={{
          "aria-label": "next page",
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
};

export default ExtendConsiderationPeriodTable;
